import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var ContainerEvent = /** @class */ (function (_super) {
    __extends(ContainerEvent, _super);
    function ContainerEvent(type, container, index) {
        if (container === void 0) { container = null; }
        if (index === void 0) { index = null; }
        var _this = _super.call(this, type) || this;
        _this.container = container;
        _this.index = index;
        return _this;
    }
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    ContainerEvent.prototype.clone = function () {
        return new ContainerEvent(this.type, this.container, this.index);
    };
    /**
     *
     */
    ContainerEvent.ADD_CHILD_AT = 'addChildAt';
    /**
     *
     */
    ContainerEvent.REMOVE_CHILD_AT = 'removeChildAt';
    return ContainerEvent;
}(EventBase));
export { ContainerEvent };
